import moment from 'moment'

export const searchItems = [
  {
    label: '设备sn',
    type: 'input',
    decorator: ['deviceSn'],
    placeholder: '请输入设备sn'
  },
  {
    label: '错误码',
    type: 'input',
    decorator: ['errorCode'],
    placeholder: '请输入错误码'
  },
  // 展示名称
  {
    label: '采集方式',
    type: 'select',
    decorator: ['idInfoCollectTypes'],
    mode: 'multiple',
    placeholder: '请选择',
    option: {data: [], key: 'code'}
  },
  // 查询时间
  {
    label: '查询时间',
    type: 'timeRange',
    decorator: [
      'dateTimeRange',
      {
        initialValue: [moment().startOf('day'), moment().endOf('day')]
      }
    ],
    placeholder: ['查询时间 (起始)', '查询时间 (终止)'],
    disabledDate: c => c && c > moment().endOf('day'),
    ranges: {
      今日: [moment().startOf('day'), moment().endOf('day')],
      近一周: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
      近两周: [moment().subtract(15, 'days').startOf('day'), moment().endOf('day')],
      近一月: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')]
    }
  }
]
